export default __webpack_public_path__ + "static/media/enugu-frame.56407af5.png";